module.exports = __webpack_public_path__ + "static/img/iPhone7Plus.b33e1cd6.png";